import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
      <div className="container mx-auto px-4 py-16">
        <div className="text-center max-w-2xl mx-auto">
          {/* 404 图标 */}
          <div className="mb-8">
            <div className="text-8xl font-bold text-gray-300 mb-4">404</div>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>

          {/* 错误信息 */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t('notFound.title', '页面未找到')}
          </h1>
          
          <p className="text-lg text-gray-600 mb-8">
            {t('notFound.description', '抱歉，您访问的页面不存在或已被移动。')}
          </p>

          {/* 操作按钮 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              variant="primary"
              size="lg"
              onClick={handleGoHome}
              className="px-8"
            >
              {t('notFound.goHome', '返回首页')}
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              onClick={handleGoBack}
              className="px-8"
            >
              {t('notFound.goBack', '返回上页')}
            </Button>
          </div>

          {/* 推荐链接 */}
          <div className="text-left">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('notFound.suggestions', '您可能想要访问：')}
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div 
                className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => navigate('/products')}
              >
                <h3 className="font-medium text-gray-900 mb-2">
                  {t('nav.products', '版权产品')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('notFound.productsDesc', '浏览丰富的版权产品资源')}
                </p>
              </div>

              <div 
                className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => navigate('/talents')}
              >
                <h3 className="font-medium text-gray-900 mb-2">
                  {t('nav.talents', '版权人才')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('notFound.talentsDesc', '查找专业的版权领域人才')}
                </p>
              </div>

              <div 
                className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => navigate('/copyright')}
              >
                <h3 className="font-medium text-gray-900 mb-2">
                  {t('nav.copyright', '版权登记')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('notFound.copyrightDesc', '了解版权登记服务')}
                </p>
              </div>

              <div 
                className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => navigate('/about')}
              >
                <h3 className="font-medium text-gray-900 mb-2">
                  {t('nav.about', '关于我们')}
                </h3>
                <p className="text-sm text-gray-600">
                  {t('notFound.aboutDesc', '了解平台信息和联系方式')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default NotFound; 